import React from "react";
import styled from "styled-components";
import {AlertErrorCont, IconAlertPlace, AlertInfoText} from "./AlertErrorSmall";
import {FiCheckIcon} from "./AlertBig";

const AlertSuccessCont = styled(AlertErrorCont)`

`

const IconSuccessPlace = styled(IconAlertPlace)`
    background-color: var(--it-text-green);
`

export const AlertSuccessSmall = ({children, title}) => {
	return (
		<AlertSuccessCont>
			<IconSuccessPlace>
				<FiCheckIcon
					size={20}
				/>
			</IconSuccessPlace>
			<AlertInfoText data-green>
				{title}
			</AlertInfoText>
		</AlertSuccessCont>
	)
}